export enum NetworkType {
    Structure = 'Network Structure',
    Lines = 'Network Lines',
    Device = 'Equipment'
}

export enum NetworkLines {
    HV = 'HV Poles',
    MV = 'MV Poles',
    LV = 'LV Poles'
}